import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../utilities/modalHOC';
import {
  setCouponDetail,
  setDeleteCoupon,
  setLoadCoupons,
} from '../../Coupons/actions';
import {
  createNewCoupon,
  listPlansSubscriptions,
  loadNewCouponsAction,
} from '../../Coupons/actionsSagas';
import {
  getCouponDetail,
  getDeleteCoupon,
  getLoadCoupons,
  getNewCoupons,
  setPlansSubscriptions,
} from '../../Coupons/selectors';
import { getPermissions } from '../../Login/selectors';
import newCouponsList from './newCouponsList';

const mapStateToProps = (state, ownProps) => ({
  newCoupons: getNewCoupons(state),
  couponDetail: getCouponDetail(state),
  loadCoupons: getLoadCoupons(state),
  plansSubscriptions: setPlansSubscriptions(state),
  deleteCoupon: getDeleteCoupon(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadNewCoupons: () => dispatch(loadNewCouponsAction()),
  setCouponDetail: (value) => dispatch(setCouponDetail(value)),
  createNewCoupon: (value) => dispatch(createNewCoupon(value)),
  loadCouponAction: (value) => dispatch(setLoadCoupons(value)),
  listPlansSubscriptions: () => dispatch(listPlansSubscriptions()),
  setDeleteCoupon: (value) => dispatch(setDeleteCoupon(value)),
});

const newCouponListContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(newCouponsList);

export default addAbilityToOpenModal(newCouponListContainer);
